module.exports.INDIVIDUAL_DEDUCTIBLE = 'deductible';
module.exports.FAMILY_DEDUCTIBLE = 'familyDeductible';
module.exports.INDIVIDUAL_OOP = 'oopMax';
module.exports.FAMILY_OOP = 'familyOopMax';
module.exports.OUT_NETWORK_TIER = 'OUT-NETWORK';
module.exports.SOURCE_CODE_IFP = 'AP';
module.exports.GAC_ONLY = 'GACONLY';
module.exports.INPATIENT = 'Inpatient';
module.exports.OUTPATIENT = 'Outpatient';
module.exports.PERSON = 'Person';
module.exports.ORGANIZATION = 'Organization';
module.exports.PLACE = 'Place';
module.exports.PRE_D = 'PRE_D';
module.exports.DENTAL_PLAN_MAX = 'dentalPlanMax';
module.exports.FAMILY_DENTAL_PLAN_MAX = 'familyDentalPlanMax';
module.exports.VISION_MATERIALS = 'VisionMaterials';
module.exports.NO_BENEFITS = 'NoBenefits';
module.exports.LOW_USAGE_CODE = 'LowUsageCode';
module.exports.REV_DUPLICATE = 'RevDuplicate';

/* This mapping is needed since shoppable services API returns the key here and FPC Cost Calc expects the values */
module.exports.PROVIDER_TYPE_CONVERSION_FPC = {
    Person: 'Person',
    Organization: 'Place',
    Place: 'Place',
};

module.exports.PROVIDER_LABELS_MAP = {
    place: 'CLINICS AND FACILITIES',
    medicalGroup: 'MEDICAL GROUPS',
    person: 'HEALTH CARE PROFESSIONALS',
};

module.exports.CARE_PATH_CATEGORY_CODE = {
    MEDICAL: 'M',
    BEHAVIORAL: 'B',
    DENTAL: 'D',
    VISION: 'V',
    PHYSICAL: 'A',
};

module.exports.CATEGORY_CODE_MAP = {
    M: 'medical',
    B: 'behavioral',
    D: 'dental',
    V: 'vision',
    A: 'medical',
};

module.exports.COVERAGE_TYPE = {
    MEDICAL: 'MEDICAL',
    BEHAVIORAL: 'BEHAVIORAL',
    DENTAL: 'DENTAL',
    VISION: 'VISION',
};

module.exports.COVERAGE_TYPE_CODE = {
    D: 'D',
    DS: 'DS',
    OPH: 'OPH',
};

/**
 * For INN Estimates with no providers available
 */
module.exports.SHELL_INN_PROVIDER = {
    label: 'CLINICS AND FACILITIES',
    unTranslatedText: '',
    providerDigestId: '',
    name: '',
    resourceType: 'Organization',
    active: true,
    type: 'Place',
    locationInfo: [
        {
            singleAddress: {
                city: '',
                line: [''],
                postalCode: '',
                state: '',
            },
        },
    ],
};

module.exports.BENEFITS_SERVICE_ERROR_CODES = {
    MEMBER_NOT_FOUND: {
        code: ['B003', 'B031', 'B034', 'B038'],
        displayMessage: 'Member Not Found',
    },
    MEMBER_NOT_SUPPORTED: {
        code: ['B014', 'B015'],
        displayMessage: 'Member Not Supported',
    },
    NO_ACTIVE_COVERAGE: {
        code: ['B013'],
        displayMessage: 'Member has No Active Coverage',
    },
};

module.exports.ORCHESTRATION_SERVICE_ERROR_CODES = {
    GAC_NOT_AVAILABLE: {
        code: ['OR11', 'OR12'],
        displayMessage: 'GeoAverage Cost Not Available',
    },
    NO_OON_RATES_OR_BENEFITS: {
        code: ['OR16'],
        displayMessage: 'Orchestration - No OON Benefits',
    },
    NO_OON_RATES: {
        code: ['OR15'],
        displayMessage: 'Orchestration - No OON Rates',
    },
    NO_GAC_OR_PAC_RATES: {
        code: ['OR17', 'OR18', 'OR20', 'PD002', 'PD018', 'PD024', 'PD027'],
        displayMessage:
            'We apologize for the inconvenience. We are unable to provide an estimate at this time. Please call the member phone number on your health plan ID card.',
    },
};

module.exports.PROVIDER_SEARCH_SERVICE_ERROR_CODES = {
    PROVIDERS_NOT_FOUND: {
        code: ['P003'],
        displayMessage: 'Providers not found for selected service and searched location radius',
    },
    NO_NETWORKS_OR_COVERAGES: {
        code: ['P012'],
        displayMessage: 'No plan network indicators found in networks and/or no valid coverages',
    },
};

module.exports.ERROR_CODE_HEADER = 'x-epe-error-code';
module.exports.ERROR_MESSAGE_HEADER = 'x-epe-error-message';
module.exports.EPE_CORRELATION_ID = 'x-epe-correlationid';

/**
 * Route names
 */
module.exports.BASE_ROUTE = '/';
module.exports.LOGIN_ROUTE = '/login';
module.exports.SEARCH_ROUTE = '/search';
module.exports.SINGLE_ESTIMATE_ROUTE = '/estimate';
module.exports.ESTIMATES_ROUTE = '/estimates';
module.exports.ERROR_ROUTE = '/error';

/**
 * Key values for Accessibility navigation
 */
module.exports.ENTER_KEY = 'Enter';
module.exports.TAB_KEY = 'Tab';
module.exports.SHIFT_KEY = 'Shift';
module.exports.ARROW_DOWN_KEY = 'ArrowDown';
module.exports.CURSOR_POINTER = 'pointer';

/**
 * Dental Backup/Defaults
 */
module.exports.DEFAULT_TOOTH_RANGE = {
    beginPosition: 1,
    endPosition: 32,
};

/**
 * UHG considers these partners different payers than UHC
 */
module.exports.UHC_PARTNER_ID = {
    DEFAULT_UHC: 'uhc',
    EMPIRE: 'uhc.empire',
    MEDICARE: 'uhc.mnr',
    UHC_WEST: 'uhc.west',
    OXFORD: 'uhc.oxhp',
    OXFORD_POLARIS: 'uhc.oxford.polaris',
    MEDICAID: 'uhc.medicaid',
    EXCHANGE: 'uhc.exchange',
    SIERRA: 'uhc.sierra',
    OBH: 'obh',
    ADVANTAGE: 'advantage',
};

module.exports.LINE_OF_BUSINESS = {
    ENI: 'E&I',
    MNR: 'M&R',
    CNS: 'C&S',
    EXCHANGE: 'Exchange',
};

module.exports.MEMBERSHIP_CATEGORY = {
    OXFORD: 'OXFORD',
    UHC_WEST: 'UHC WEST',
    PUBLIC_EXCHANGE: ['PUBLIC EXCHANGE', 'PUBLIC_EXCHANGE'],
};

module.exports.DUMMY_TIN_FOR_OBH_NON_PROVIDER = {
    tin: '123456',
};
module.exports.OBH_POPULATIONS = ['UB'];
module.exports.UMR_POPULATIONS = ['UM'];
module.exports.INN_PROVIDER = 'INN_PROVIDER';
module.exports.OON_PROVIDER = 'OON_PROVIDER';
module.exports.ESTIMATE_HISTORY_TYPES = {
    preventive: 'preventiveEstimate',
    diagnostic: 'diagnosticEstimate',
    rental: 'RR',
    purchase: 'NU',
};

module.exports.OON_NO_RATES_DISCLAIMER_ID = 'P';

module.exports.PROVIDER_TYPE_SINGLE_ESTIMATE_LABELS = {
    PERSON: 'Physician Charge',
    PLACE: 'Facility Charge',
    FACILITY: 'Facility Charge',
    ORGANIZATION: 'Organization Charge',
};
module.exports.PER_UNIT_MEASURES = {
    ambulance: 'Ambulance',
    perUnit: 'PerUnit',
};

module.exports.INDEMNITY_NO_RATES = {
    text: 'We apologize for the inconvenience. We are unable to provide an estimate at this time. Please call the member phone number on your health plan ID card.',
};

module.exports.UMR_ENI_VISION_NOBENEFITS = {
    text: 'We apologize for the inconvenience. We are unable to provide an estimate at this time. Please call the member phone number on your health plan ID card.',
};

module.exports.PH_CALIFORNIA_POLICIES = [
    'STOCKTON',
    'CH-20V-10C',
    'CH-30V-15C',
    'CH-UNLMV-$10',
    'CH-UNLMV-$20',
    'CH-UNLMV-$30',
    'CHAC-UNLMV-$0',
    'CHAC-UNLMV-$10',
    'CHAC-UNLMV-$15',
    'CHAC-UNLMV-$20',
    'CHAC-UNLMV-$30',
    'ASSOCIATED GENERAL',
    'ASSOCIATED GEN',
];

module.exports.UMR_VISION_PROD_PLANIND = 'V_IDM';

module.exports.UMR_VISION_CAREPATHS = [
    'XY17661',
    'XY17662',
    'XY17663',
    'XY17664',
    'XY17665',
    'XY17666',
    'XY17667',
    'XY17668',
    'XY17669',
    'XY17670',
    'MC883',
    'MC884',
    'MC885',
];
module.exports.FACILITY_TYPES = {
    Hospital: 'HOSP',
    FreeStandingSurgeryCenter: 'FREE_STND_SURG_CTR',
    FreeStandingRadiologyFacility: 'FREE_STND_RAD_FACL',
    FreeStandingLab: 'FREE_STND_LAB',
    Clinic: 'CLNC',
};

module.exports.VISION_COLLECTION_NAMES = {
    contact_lenses: 'Contact Lenses',
    frames: 'Frames',
    lenses: 'Lenses',
};

module.exports.VISION_DISCLAIMERS = [
    'An item or service may not be subject to cost sharing if it’s billed as a preventive service and meets requirements outlined in the Preventive Care Services Policy.',
    "The choice of provider is yours. This site is for informational purposes only. It isn't a substitute for medical, behavioral health, dental, or health care advice. This directory does not recommend a particular provider or type of behavioral health, medical, dental, or health care. If you believe you are experiencing a medical emergency, please call 911.",
    'Before scheduling an appointment or receiving services, please check with the provider and your health plan to confirm that the provider is participating, that the service is covered, and the costs that you may be charged for the service.',
    'The actual charge for the item or service may be different than the estimate, depending on the actual care you receive. For example, if your doctor provides additional services during your visit, your charges could be more than the estimate. It’s important to talk with your provider before and during your visit to confirm which items and services you will receive and to request a new estimate if new information becomes available.',
];
module.exports.PRIOR_AUTH_IDS = {
    Member_SingleBillingCode: 'A',
    Member_MultiCarepath: 'Z',
    Provider_SingleBillingCode: 'T',
    Provider_MultiCarepath: 'U',
    Provider_SingleBillingCode_ASO: 'V',
    Provider_MultiCarepath_ASO: 'W',
    SiteOfService_SingleBillingCode: 'X',
    SiteOfService_MultiCarepath: 'Y',
};

module.exports.PRIOR_AUTH_DIALOG_TEXT = {
    Member_PriorAuth_Text: 'Please contact member services with the following information:',
    Member_Provider_PriorAuth_Para1_Shared_Text:
        'Prior authorization is a coverage determination, not a treatment decision. It is the decision as to whether the requirements for coverage under your health benefit plan are met before you get a service, treatment or fill a prescription.',
    Member_Provider_PriorAuth_Para2_Shared_Text:
        "Your health insurance or plan may require prior authorization for certain services, except in an emergency. Prior authorization isn't a promise your health insurance or plan will cover the cost.",
    Provider_PriorAuth_Para3_Shared_Text:
        'Your provider is usually the one to submit a prior authorization. Ask your provider to submit it for you. A decision is typically made within 5-10 business days of hearing from your provider. Urgent requests typically take 72 hours (3 days).',
    Provider_PriorAuth_MultipleSitesOfService_Text:
        'Prior authorization is required if you have this service at an outpatient hospital. No prior authorization is needed for offices and ambulatory surgical centers.',
};
module.exports.MICRO_FRONTEND_STARGATE_KEY = 'micro-ui-stargate';

module.exports.EPE_ACCESS_TOKEN = 'x-epe-access-token';

module.exports.UMR_SOURCECODE = 'UM';

module.exports.ENABLE_COVERAGE_TYPES = true;
